import { Component, OnInit, inject, signal, OnChanges, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { LoginFormGroup, Login } from '../../shared/models/login.model';
import { ProfileService } from '../services/profile.service';
import { User } from '../../shared/models/user.model';
import { ProfileEnum } from '../profile-enum';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { RoutesService } from '../../shared/services/routes.service';
import { AutoFocusModule } from 'primeng/autofocus';
import { TokenModel } from '../../shared/models/token.model';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../shared/services/notification.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    InputTextModule,
    ButtonModule,
    DialogModule,
    AutoFocusModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit, OnChanges {
  profileService = inject(ProfileService)
  routesService = inject(RoutesService)
  notificationService = inject(NotificationService)
  //
  user: User | null | undefined;
  enum = ProfileEnum;
  //
  loginFormGroup!: FormGroup<LoginFormGroup>;
  //
  labelClass = signal<string>('block text-white font-medium mb-2 mt-2');
  profile = signal<User | undefined>(undefined)
  //
  dialogVisible: boolean = false;
  constructor(
    private router: Router,
  ) {
    this.loginFormGroup = new FormGroup({
      username: new FormControl<string>('', [Validators.required, Validators.minLength(3)]),
      password: new FormControl<string>('', [Validators.required, Validators.minLength(3)]),
    });
  }
  //
  ngOnInit(): void {
    this.profileService.title.update((value) => 'Login')
    this.profile = this.profileService.profile;
    this.loginFormGroup.get(this.enum.username)?.events.subscribe((event) => {
      // console.log('username event: ',event);
    });
    this.loginFormGroup.get(this.enum.password)?.events.subscribe((event) => {
      // console.log('password event: ',event);
    });
    return
  }
  //
  ngOnChanges(changes: SimpleChanges): void {
    // console.log('Profile: ', changes['profile'])
  }
  //
  signIn () {
    if (this.loginFormGroup.invalid) {
      this.loginFormGroup.markAllAsTouched(); // Marca todos los campos como tocados para mostrar los errores
      return;
    }
    const login: Login = {
      username: this.loginFormGroup.value.username || '',
      password: this.loginFormGroup.value.password || '',
    }
    this.profileService.login(login).subscribe({
      next: async (res) => {
        if (res) {
          this.profileService.setToken(res as TokenModel)
          await this.profileService.getProfile()
          this.router.navigate(['/'])
        } else {
          this.notificationService.error('Login failed');
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error(err);
        this.notificationService.error(err.message);
        this.loginFormGroup.get(this.enum.username)?.setErrors({ invalidUsername: true });
        this.loginFormGroup.get(this.enum.password)?.setErrors({ invalidPassword: true });
        // if (err.message.search(/usario/) !== -1) {
        // }
        // if (err.message.search(/contraseña/)!== -1) {
        // }
      }
    });
  }
  isInvalid(name: string): boolean | undefined {
    return this.loginFormGroup.get(name)?.invalid && (this.loginFormGroup.get(name)?.dirty || this.loginFormGroup.get(name)?.touched)
  }
}
